// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_angular_material___ivy_ngcc___fesm2015_button_js-src_app_components_form-5f2b7a":"e61c1f6543600fd4812a","src_app_pages_sign-in_sign-in_module_ts":"37e2aa99dd92d1356eb5","src_app_pages_home_home_module_ts":"d031c922138e35cb1e4c"}[chunkId] + ".js";
};